import { BatchLevelSubScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import {
  filteredBatchLevelSubScreen,
  filteredBatchLevelSubScreenLink,
  filteredNCFileLevelSubScreen,
  filteredNCFileLevelSubScreenLink,
} from '../../../common/constants/base.constants';
import { NcFileBatchEventsLink, NcFileBatchEventType } from '@v2/pages/common/enums';
import { createLevelSubScreenLinking } from '@v2/pages/common/helpers';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { ToolLevelSubScreen, ToolLevelSubScreenLink, ToolsDetailsScreen, ToolsDetailsScreenLink } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { ToolsDetailsBatch } from '@v2/pages/tools/details/modules/batch/ToolsDetailsBatch';
import { ToolsDetailsJobs } from '@v2/pages/tools/details/modules/jobs/ToolsDetailsJobs';
import {
  ToolsDetailsNCFilePerformanceActive,
  ToolsDetailsNCFilePerformanceNavigator,
  ToolsDetailsNCFilePerformancePaid,
  ToolsDetailsNCFilePerformanceProductive,
  ToolsDetailsNCFilePerformanceUtilization,
  ToolsDetailsNCFileEventsActive,
  ToolsDetailsNCFileEventsChange,
  ToolsDetailsNCFileEventsCycle,
  ToolsDetailsNCFileEventsNavigator,
  ToolsDetailsNCFileEventsSetup,
  ToolsDetailsNCFileEventsTrace,
  ToolsDetailsNCFile,
  ToolsDetailsNCFileDocuments,
  ToolsDetailsNCFileLinks,
  ToolsDetailsNCFileTimeline,
  ToolsDetailsNCFileTimes,
  ToolsDetailsNCFileVersions,
  ToolsDetailsNCFileTraceability,
} from '../modules/nc-file';
import { ToolsDetailsPart } from '@v2/pages/tools/details/modules/part/ToolsDetailsPart';
import { ToolsDetailsTools } from '@v2/pages/tools/details/modules/tools/ToolsDetailsTools';
import { ToolsDetailsBatchNavigator } from './ToolsDetailsBatchNavigator';
import { ToolsDetailsJobNavigator } from './ToolsDetailsJobNavigator';
import { ToolsDetailsNCFileNavigator } from './ToolsDetailsNCFileNavigator';
import { ToolsDetailsPartNavigator } from './ToolsDetailsPartNavigator';
import { ToolsDetailsToolNavigator } from './ToolsDetailsToolNavigator';
import { timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalArrayItems } from '@helpers';
import { NCFileLevelSubScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { PartLevelSubScreen } from '@v2/pages/part/details/common/enums/partDetails.enum';
import { JobLevelSubScreen } from '@v2/pages/job/common/enums/jobDetails.enum';

export const ToolsDetailsScreenName = 'ToolsDetailsV2';

export const toolsDetailsLinking = {
  path: 'tools/details',
  screens: {
    [ToolsDetailsScreen.PART]: {
      path: ToolsDetailsScreenLink.PART,
      screens: createLevelSubScreenLinking(ToolsDetailsScreen.PART),
    },
    [ToolsDetailsScreen.BATCH]: {
      path: ToolsDetailsScreenLink.BATCH,
      screens: createLevelSubScreenLinking(ToolsDetailsScreen.BATCH, {
        levels: filteredBatchLevelSubScreen,
        links: filteredBatchLevelSubScreenLink,
        nestedScreens: {
          [BatchLevelSubScreen.TIMES]: {
            screenName: BatchLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [ToolsDetailsScreen.NC_FILE]: {
      path: ToolsDetailsScreenLink.NC_FILE,
      screens: createLevelSubScreenLinking(ToolsDetailsScreen.NC_FILE, {
        levels: filteredNCFileLevelSubScreen,
        links: filteredNCFileLevelSubScreenLink,
        nestedScreens: {
          [NCFileLevelSubScreen.TIMES]: {
            screenName: NCFileLevelSubScreen.TIMES,
            items: NcFileBatchEventType,
            links: NcFileBatchEventsLink,
          },
        },
      }),
    },
    [ToolsDetailsScreen.JOBS]: {
      path: ToolsDetailsScreenLink.JOBS,
      screens: createLevelSubScreenLinking(ToolsDetailsScreen.JOBS),
    },
    [ToolsDetailsScreen.TOOLS]: {
      path: ToolsDetailsScreenLink.TOOLS,
      screens: createLevelSubScreenLinking(ToolsDetailsScreen.TOOLS, {
        levels: ToolLevelSubScreen,
        links: ToolLevelSubScreenLink,
      }),
    },
  },
};

export const toolsDetailsConfig = [
  { name: ToolsDetailsScreen.PART, Component: ToolsDetailsPartNavigator },
  { name: ToolsDetailsScreen.BATCH, Component: ToolsDetailsBatchNavigator },
  { name: ToolsDetailsScreen.NC_FILE, Component: ToolsDetailsNCFileNavigator },
  { name: ToolsDetailsScreen.JOBS, Component: ToolsDetailsJobNavigator },
  { name: ToolsDetailsScreen.TOOLS, Component: ToolsDetailsToolNavigator },
];

export const toolsDetailsPartConfig = [
  {
    name: `${ToolsDetailsScreen.PART}${PartLevelSubScreen.GENERAL}`,
    Component: ToolsDetailsPart,
  },
  // {
  //   name: `${ToolsDetailsScreen.PART}${PartLevelSubScreen.TIMES}`,
  //   Component: ToolsDetailsPart,
  // },
  // {
  //   name: `${ToolsDetailsScreen.PART}${PartLevelSubScreen.VERSIONS}`,
  //   Component: ToolsDetailsPart,
  // },
  // {
  //   name: `${ToolsDetailsScreen.PART}${PartLevelSubScreen.LINKS}`,
  //   Component: ToolsDetailsPart,
  // },
  {
    name: `${ToolsDetailsScreen.PART}${PartLevelSubScreen.DOCUMENTS}`,
    Component: ToolsDetailsPart,
  },
];

export const toolsDetailsToolConfig = [
  {
    name: `${ToolsDetailsScreen.TOOLS}${ToolLevelSubScreen.GENERAL}`,
    Component: ToolsDetailsTools,
  },
];

export const toolsDetailsBatchConfig = [
  {
    name: `${ToolsDetailsScreen.BATCH}${BatchLevelSubScreen.GENERAL}`,
    Component: ToolsDetailsBatch,
  },
  {
    name: `${ToolsDetailsScreen.BATCH}${BatchLevelSubScreen.TIMELINE}`,
    Component: ToolsDetailsBatch,
  },
  // {
  //   name: `${ToolsDetailsScreen.BATCH}${BatchLevelSubScreen.TIMES}`,
  //   Component: ToolsDetailsBatchEventsNavigator,
  // },
  // {
  //   name: `${ToolsDetailsScreen.BATCH}${BatchLevelSubScreen.DOCUMENTS}`,
  //   Component: ToolsDetailsBatch,
  // },
];

export const toolsDetailsNCFileConfig = [
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.GENERAL}`,
    Component: ToolsDetailsNCFile,
  },
  // Based on task SF-4963
  // ...injectConditionalArrayItems(timelineAvailable, {
  //   name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMELINE}`,
  //   Component: ToolsDetailsNCFileTimeline,
  // }),

  // {
  //   name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
  //   Component: ToolsDetailsNCFileTimes,
  // },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}`,
    Component: ToolsDetailsNCFileEventsNavigator,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}`,
    Component: ToolsDetailsNCFilePerformanceNavigator,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.VERSIONS}`,
    Component: ToolsDetailsNCFileVersions,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.LINKS}`,
    Component: ToolsDetailsNCFileLinks,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.DOCUMENTS}`,
    Component: ToolsDetailsNCFileDocuments,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TRACEABILITY}`,
    Component: ToolsDetailsNCFileTraceability,
  }
];

export const toolsDetailsJobsConfig = [
  {
    name: `${ToolsDetailsScreen.JOBS}${JobLevelSubScreen.GENERAL}`,
    Component: ToolsDetailsJobs,
  },
  // {
  //   name: `${ToolsDetailsScreen.JOBS}${JobLevelSubScreen.TIMES}`,
  //   Component: ToolsDetailsJobs,
  // },
  // {
  //   name: `${ToolsDetailsScreen.JOBS}${JobLevelSubScreen.VERSIONS}`,
  //   Component: ToolsDetailsJobs,
  // },
  // {
  //   name: `${ToolsDetailsScreen.JOBS}${JobLevelSubScreen.LINKS}`,
  //   Component: ToolsDetailsJobs,
  // },
  {
    name: `${ToolsDetailsScreen.JOBS}${JobLevelSubScreen.DOCUMENTS}`,
    Component: ToolsDetailsJobs,
  },
];

export const ncFilePerformanceConfig = [
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.active}`,
    Component: ToolsDetailsNCFilePerformanceActive,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.productive}`,
    Component: ToolsDetailsNCFilePerformanceProductive,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.paid}`,
    Component: ToolsDetailsNCFilePerformancePaid,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.PERFORMANCE}${navigationLevels.metricTypes.utilization}`,
    Component: ToolsDetailsNCFilePerformanceUtilization,
  },
];

export const ncFileEventsConfig = [
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CYCLE}`,
    Component: ToolsDetailsNCFileEventsCycle,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.ACTIVE}`,
    Component: ToolsDetailsNCFileEventsActive,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.CHANGE}`,
    Component: ToolsDetailsNCFileEventsChange,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.SETUP}`,
    Component: ToolsDetailsNCFileEventsSetup,
  },
  {
    name: `${ToolsDetailsScreen.NC_FILE}${NCFileLevelSubScreen.TIMES}${NcFileBatchEventType.TRACE}`,
    Component: ToolsDetailsNCFileEventsTrace,
  },
];
